import { dictionary } from "@dcc/lookup/dictionary/dictionary";
import { DictionaryField } from "@dcc/lookup/dictionary/fields";

export const useDictionary = () => {
  return {
    DictionaryField,
    dictionary
  };
};
